define('SageDotCom/PatternAnimations/animations',[
    "jquery",
    "TweenMax",
    "ScrollMagic",
    "AnimationPlugin",
    "SageDotCom/Utility/PageModeHelper",
    "SageDotCom/PatternAnimations/numbersCountUp",
    "SageDotCom/PatternAnimations/animatedSlickSlider",
    "SageDotCom/PatternAnimations/pattern",
    "SageDotCom/PatternAnimations/animatedCtaButton",
    "SageDotCom/PatternAnimations/deviceScroller",
    "SageDotCom/PatternAnimations/animatedBoxes"

],
    function (
        $,
        TweenMax,
        ScrollMagic,
        AnimationPlugin,
        PageModeHelper,
        numbersCountUp,
        animatedSlickSlider,
        patternAnimations,
        animatedCtaButton,
        deviceScroller,
        animatedBoxes
    ) {
    function animations() { }

    var animationInitialising = false;
    animations.prototype.initialize = function () {
        if (!PageModeHelper.IsExperienceEditor() && !animationInitialising) {
            animationInitialising = true;
            setTimeout(numbersCountUp.initialize.bind(numbersCountUp), 0);
            setTimeout(animatedSlickSlider.initialize.bind(animatedSlickSlider), 0);
            setTimeout(patternAnimations.initialize.bind(patternAnimations), 0);
            setTimeout(animatedCtaButton.initialize.bind(animatedCtaButton), 0);
            setTimeout(deviceScroller.initialize.bind(deviceScroller), 0);
            setTimeout(animatedBoxes.initialize.bind(animatedBoxes), 0);

        }
    };

    return new animations();
});

